import { CountryTypesComponents } from '../../../api/types'

import { getCountryCode } from '../../../api'

let countryIdPromise: Promise<CountryTypesComponents['schemas']['CountryResponseV3Ip']['code']> | null = null

export const getCountryId = async (apiDomain: string) => {
  if (countryIdPromise === null) {
    countryIdPromise = getCountryCode(apiDomain)
      .then((country) => country.code)
      .catch((error) => {
        console.error(error)

        return 'ZZ'
      })
  }

  return countryIdPromise
}
